<template>
  <div class="printQRCodeList">
    <el-card>
      <el-button type="primary" slot="header" @click="returnprintQRCodeList">{{$t('lang.btn_returnprintQRCodeList')}}</el-button>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addPointOrder')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.dutyListCheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="name" :label="$t('lang.lbl_duties_name')"></el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="changeTitle"
      @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws3" :rules="rules" class="form_show">
        <el-form-item :label="$t('lang.lbl_duties_name')" prop="name">
          <el-input v-model="form.name" :placeholder="$t('lang.lab_writeDuties_name')" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_pointOrder')" prop="msg">
          <draggable
            :list="form.pointJsonArray"
            :disabled="!enabled"
            class="list-group"
            ghost-class="ghost"
            :move="checkMove"
          >
            <div
              class="list-group-item"
              v-for="element in form.pointJsonArray"
              :key="element.pointId"
            >
            <i class="el-icon-sort"></i>
            <span class="span-center">{{ element.msg }}</span>
            </div>
          </draggable>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rest('form')" class="cancel">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled"  @click="editPoing('form')" v-if="isAdd === 0">{{$t('lang.btn_save')}}</el-button>
        <el-button type="primary" @click="addPoint('form')" v-if="isAdd === 1">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:pointOrderSetting
 *@Description:点位顺序设置列表/弹框
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-20
 */
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'

export default {
  components: {
    draggable
  },
  data() {
    return {
      enabled: true,
      isAdd: 1, // 默认为添加顺序
      multipleSelection: [], // 多选框
      PlanarGraphId: '', // 巡检类型ID
      PatrolTypeId: '', // 平面图ID
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      pointPosition: '', // 点位的绑定值
      show: false, // 弹框默认不显示
      changeTitle: '', // 动态的弹框标题
      editId: '', // 点击编辑保存当时的id
      SequenceJson: [], // 添加保存时存放参数的SequenceJson
      form: {
        pointJsonArray: [], // 添加顺序的接收列表
        name: '',
        msg: ''
      },
      rules: {
        name: [
          { required: true, message: this.$i18n.t('lang.lab_inputPointName'), trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      dutyListCheckbox: require('@/config/enum').dutyListCheckbox // 是否隐藏复选框
    }
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    form: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.PlanarGraphId = this.$route.query.id
    this.PatrolTypeId = this.$route.query.typeId
    this.getTablelist()
  },
  methods: {
    // checkMove
    checkMove() {
      
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.form.name = ''
      this.$refs.form.clearValidate()
    },
    // 返回打印二维码
    returnprintQRCodeList () {
      this.$router.push({ name: 'printQrCodeList' })
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 点位顺序
    getTablelist() {
      let loading = this.$loading()
      this.$get(`/patrolPointSequence?GardenId=${this.gardenId}&PlanarGraphId=${this.PlanarGraphId}&PatrolTypeId=${this.PatrolTypeId}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    edit(id) {
      this.isAdd = 0
      this.changeTitle = this.$i18n.t('lang.btn_editPointOrder')
      let loading = this.$loading()
      this.$get(`/patrolPointSequenceById/` + id).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.editId = id
            this.form.name = res.patrolPointSequence.name
            this.form.pointJsonArray = JSON.parse(res.patrolPointSequence.sequenceJson)
            this.show = true
            this.saveData = JSON.stringify(this.form)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 编辑顺序确定
    editPoing(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          let params = {
            GardenId: this.gardenId,
            PlanarGraphId: this.PlanarGraphId,
            PatrolTypeId: this.PatrolTypeId,
            Name: this.form.name,
            SequenceJson: JSON.stringify(this.form.pointJsonArray)
          }
          this.$patch(`/patrolPointSequence/${this.editId}`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.show = false
                this.getTablelist()
              }
              setTimeout(() => {
                loading.close()
              }, 200)
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 清空弹框
    rest(form) {
      this.$refs[ form ].resetFields()
      this.form.name = ''
    },
    // 添加顺序
    add() {
      this.isAdd = 1
      this.form.name = ''
      this.form.msg = ''
      this.changeTitle = this.$i18n.t('lang.btn_addPointOrder')
      this.show = true
      let loading = this.$loading()
      this.$get(`/patrolPointList?GardenId=${this.gardenId}&PlanarGraphId=${this.PlanarGraphId}&PatrolTypeId=${this.PatrolTypeId}`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.pointJsonArray = res.pointJsonArray
            this.form.msg = this.form.pointJsonArray[0].msg
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加顺序保存
    addPoint(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let tempSeqJson = {}
          for (let index = 0; index < this.form.pointJsonArray.length; index++) {
            const element = this.form.pointJsonArray[index]
            tempSeqJson[index] = element
          }
          let params = {
            Name: this.form.name,
            PatrolTypeId: this.PatrolTypeId,
            PlanarGraphId: this.PlanarGraphId,
            GardenId: this.gardenId,
            sequenceJson: JSON.stringify(tempSeqJson),

          }
          let loading = this.$loading()
          // 为了匹配Swagger标签，content-type传递application/json格式
          this.$postJson(`/patrolPointSequence/`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.show = false
                this.getTablelist()
              }
              setTimeout(() => {
                loading.close()
              }, 200)
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/patrolPointSequence/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
  .list-group-item {
    width: 410px;
    border-radius: 4px;
    text-align: center;
    margin-bottom: 5px;
    background-color: #ededed;
    font-size: 1.4em;
    font-weight: 400;
    color: #555;
  }
  .el-icon-sort {
    float: left;
    line-height: 40px;
    padding-left: 30px;
  }
  .span-center {
    margin-left: -40px;
  }
</style>
